export default {
}



// WEBPACK FOOTER //
// src/store/authen/getters.js